export default "__VITE_PUBLIC_ASSET__9b77d94e__"